export function isAuthenticated() {
    const token = localStorage.getItem('user_token');
    return token;
}